// extracted by mini-css-extract-plugin
module.exports = {"link":"IconLink_link__1z4uP","darkLink":"IconLink_darkLink__EIad1"};